import { RouteMapEntry } from '@rx-lib/models';
import { MetaTagConfig } from  './meta.service';
import { Environment, ImageStyles } from '@rx-lib/ui';

export const mapToMetaConfig = (route: RouteMapEntry, environment: Environment, imageStyles: ImageStyles): MetaTagConfig => {
  const config = {
    title: route.page.title + ' | ' + environment.title,
    description: environment.slogan,
    url: route.page.path,
    image: route.page.media[route.subIndex].media_image ? getDefaultImageStyle(route.page.media[route.subIndex].media_image, imageStyles) : environment.defaultImage
  };

  return config;
};

const getDefaultImageStyle = (image: string, imageStyles: ImageStyles): string => image.replace(imageStyles.replace_pattern, imageStyles.background_default);